import * as Long from "long";
import { selectDoghouseInfo } from "../../../selectors/selectDoghouseInfo";
import { selectModalTabId } from "../../../selectors/selectModalTabId";
import { IdModal } from "../../modals/IdModal";
import { DoghouseCategory } from "../DoghouseCategory";
export var checkDoghouseTreatAvailability = function (path) { return function (action$, state$) {
    var state = state$.value;
    var selectedDoghouseMenuTab = selectModalTabId(state, IdModal.Doghouse);
    var dogTreatInfo = selectDoghouseInfo(state);
    if (selectedDoghouseMenuTab === DoghouseCategory.GiveDoghouseBone) {
        if (dogTreatInfo.secondsLeftForFreeTreatReset > 0 &&
            dogTreatInfo.freeTreatInventoryCount.equals(Long.ZERO)) {
            return path;
        }
    }
    if (selectedDoghouseMenuTab === DoghouseCategory.GiveDoghouseBonePrm) {
        if (dogTreatInfo.premiumTreatInventoryCount.equals(Long.ZERO)) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/check/checkDoghouseTreatAvailability.ts
// module id = 1837
// module chunks = 3